<div class="modal-header">
    <h4 class="modal-title">Manage Bidders - {{ bid.job }}</h4>
</div>
<div class="modal-body" style="max-height: 70vh; overflow-y: auto">
    <div class="row mb-3">
        <div class="col-md-6">
            <label for="lowEstimate" class="form-label">Low Estimate</label>
            <wj-input-number
                id="lowEstimate"
                [(value)]="bid.lowEstimate"
                [format]="'C0'"
                [step]="1"
                style="width: 100%"
                [isRequired]="false"
            ></wj-input-number>
        </div>
        <div class="col-md-6">
            <label for="highEstimate" class="form-label">High Estimate</label>
            <wj-input-number
                id="highEstimate"
                [(value)]="bid.highEstimate"
                [format]="'C0'"
                [step]="1"
                style="width: 100%"
                [isRequired]="false"
            ></wj-input-number>
        </div>
    </div>
    <div class="mb-3">
        <button type="button" class="btn btn-sm btn-primary" (click)="addBidder()"><fa-icon [icon]="faPlus"></fa-icon> Add Bidder</button>
    </div>
    <div class="alert alert-info" [hidden]="competitorBids.length > 0">
        <p class="mb-0">No bidders added yet. Click "Add Bidder" to get started.</p>
    </div>
    <wj-flex-grid
        #competitorBidsGrid
        [itemsSource]="grid.view"
        [hidden]="competitorBids.length === 0"
        [headersVisibility]="1"
        (initialized)="grid.initialize(competitorBidsGrid)"
        (destroy)="grid.destroy()"
        (cellEditEnded)="cellEditEnded(competitorBidsGrid, $event)"
        [keyActionTab]="'MoveAcross'"
    >
        <wj-flex-grid-column [header]="' '" [width]="50" [isReadOnly]="true">
            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    (click)="deleteBidder(cell.item)"
                    title="Delete bidder"
                    style="display: block; margin: 0 auto"
                >
                    <fa-icon [icon]="faTrash"></fa-icon>
                </button>
            </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column
            [header]="'Competitor'"
            [binding]="'competitorId'"
            [width]="'*'"
            [dataMap]="biddersMap"
            [isRequired]="true"
        ></wj-flex-grid-column>
        <wj-flex-grid-column
            [header]="'Bid Amount'"
            [binding]="'bidAmount'"
            [width]="150"
            [format]="'C0'"
            [dataType]="'Number'"
            [isRequired]="true"
        ></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Won'" [width]="80" [align]="'center'">
            <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                <input
                    type="checkbox"
                    [checked]="cell.item.won === true"
                    (click)="$event.stopPropagation()"
                    (change)="toggleWon(cell.item, $event)"
                    title="Mark as won"
                />
            </ng-template>
        </wj-flex-grid-column>
    </wj-flex-grid>
    <div class="alert alert-info mt-3">
        <small>Bidders are automatically sorted by bid amount (lowest to highest)</small>
    </div>
</div>
<div class="modal-footer">
    <button id="btnSave" type="button" class="btn btn-primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
            <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
        } @else {
            <span>Save</span>
        }
    </button>
    <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
</div>
